import { render, staticRenderFns } from "./ExternalOrderDetails.vue?vue&type=template&id=67bbfee2"
import script from "./ExternalOrderDetails.vue?vue&type=script&lang=js"
export * from "./ExternalOrderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports